import { Component, OnInit } from '@angular/core';
import { ModalService, SelectPickupService } from '@app/core/services';
import { PickupPath } from '@app/core/models/payment-service-models.model';

@Component({
  selector: 'app-select-pickup',
  templateUrl: './select-pickup.component.html',
  styleUrls: ['./select-pickup.component.less']
})
export class SelectPickupComponent implements OnInit {
  public pickupPaths = [];
  public pickuptype: number;
  locationImageUrlPrefix = '../assets/images/location/';
  disabled: boolean;
  constructor(private modalService: ModalService, public selectPickupService: SelectPickupService) { 
    this.pickupPaths.push({
      pickupPath: PickupPath.Pickup,
      pickupPathLabel: 'Pickup',
      pickupPathImage: this.locationImageUrlPrefix + 'Take Out Icon.png',
      enabled: true,
      iconClass: 'xs-takeout-icon'
    });
    this.pickupPaths.push({
      pickupPath: PickupPath.Delivery,
      pickupPathLabel: 'Delivery',
      pickupPathImage: this.locationImageUrlPrefix + 'Delivery Icon.png',
      enabled: true,
      iconClass: 'xs-delivery-icon'
    });
  }

  ngOnInit(): void {
    this.disabled = true;
  }

  pickupPathChange(value) {
    this.disabled = false;
    this.pickuptype = value;
  }
  setPickupPath() {
    this.modalService.hideModal();
    this.selectPickupService.isPickupPathSet(this.pickuptype);
  }
}

